module.exports = __webpack_public_path__ + "fonts/montserrat-latin-400.0659a9f.woff";